/**
 * PAPPO — Profile Service
 * Atualização do próprio perfil (PUT /api/users/me): nome e/ou foto.
 * O @username é imutável e não passa por aqui.
 */

import { apiPut } from './api';

/** Campos atualizáveis do perfil. `avatar_url` = /uploads/<uuid> (POST /uploads). */
export interface ProfilePatch {
  display_name?: string;
  /** URL interna do upload, ou null para remover a foto. */
  avatar_url?: string | null;
}

/** Atualiza o perfil e devolve os campos alterados. */
export async function updateProfile(patch: ProfilePatch) {
  return apiPut<{ id: number; display_name?: string; avatar_url?: string | null }>(
    '/users/me',
    patch,
  );
}
